export const UserSavedCandidatesConst = {
  Expansions: {
    fullCandidateInfo: 'fullCandidateInfo',
    candidateSearchableOrSpotlightedInfo:
      'candidateSearchableOrSpotlightedInfo',
  },
} as const;
